<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 



  <div class="col-formed-side pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-sidebar></app-sidebar>
  </div>
  <div class="col-formed-main wrap-container p-0">


  <div class="col-md-12 big-area p-0">

<div class="wrapperi">
  <div class="p-4">
    <div class="col-12">

      <div class="pointer" (click)="goBack()">
          <p class="semiboldtextblue16 mb-0"><i class="fal normaltextblue16 fa-chevron-left icon-blue me-2"></i>Takaisin</p>
      </div>
  </div>
  </div>


      <div class="col-12 d-flex justify-content-center" *ngIf="showLogoErr">
        <div class="alert alert-danger">
          <p class="">Yritykselläsi ei ole logoa lisättynä! Mikäli logoa ei lisätä näytetään sen tilalla Formedin logo</p>
        </div>
      </div>

  
      <div class="ps-4 pe-4 pt-2">
        <div class="bg-w">
          <div class="p-4">
      <div class="col-12 col-md-12 p-0 input-cover mt-4">
        <div class="col-12 p-0 mt-4">
          <div class="alert alert-warning" *ngIf="messageErr">
            <p class="text-center">Samalla nimellä löytyi jo</p>
          </div>
        </div>

  
        <div id="loader" class="loader-container mt-4" style="display:none">
          <div class="loader mx-auto"></div>
          <p class="text-center pt-3">Paikkaa lisätään...</p>
        </div>
  
        <div style="display: block;" id="form-container" class="">
          <form class="flex-row add-asd-form" [formGroup]="form"
          (ngSubmit)="onSubmit()">

          <p class="semiboldgraytext16 mb-1">Otsikko</p>
          <p class="normaltextgray14 mb-0"><span class="normaltextred14">Max 70 merkkiä </span>Kirjoita tähän ilmoituksellesi otsikkko ({{charLen}}/70)</p>
          <div class="form-floating mb-2 col-12 col-md-8 ps-0 pt-2">
            <input (keyup)="countChars()" type="text" placeholder="Otsikko" formControlName="title" id="title" class="form-control" >
            <label for="title">Otsikko</label>

         </div>

         
        <!-- Etunimi ja sukunimi -->
        <p class="semiboldgraytext16 mb-1 mt-4">Valitse alue</p>
        <p class="normaltextgray14 mb-0">Valitse alue, johon tarvitsette työvoimaa</p>
        <div class="col-12 row m-0 pt-2">

            <div class="form-floating mb-2 col-4  p-0">
                <select type="text" id="area-id" placeholder="Alue" formControlName="area" class="form-control" >
                    <option value=""></option>
                    <option *ngFor="let data of wellfareAreas" value="{{data.id}}">{{data.name_fi}}</option>
                    </select>
                <label for="area-id">Alue*</label>
            </div>
        </div>

        
          <!-- Etunimi ja sukunimi -->
          <p class="semiboldgraytext16 mb-1 mt-4">Haettava positio:</p>
          <p class="normaltextgray14 mb-0">Valitse ammattilainen</p>
          <div class="col-12 row m-0 pt-2">
                    
            <div class="col-4 ps-0">
              <div class="form-floating mb-2 p-0">
                <select (change)="mdtypeSelected($event)" type="text" id="md-type" placeholder="Poisitio" class="form-control" >
                  <option value=""></option>
                  <option *ngFor="let data of mdGroups" value="{{data.id}}">{{data.name_fi}}</option>
                  </select>
                <label for="md-type">Positio*</label>
            </div>
            </div>
            <div class="col-4">
              <div class="form-floating mb-2 p-0" *ngIf="selectedSubtypes && selectedSubtypes.length > 0">
                <select type="text" (change)="selectSubtype()" id="md-sub-type" placeholder="Poisitio" class="form-control" >
                  <option value=""></option>
                  <option *ngFor="let data of selectedSubtypes" value="{{data.id}}">{{data.name_fi}}</option>
                  </select>
                <label for="md-sub-type">Erikoisala*</label>
            </div>
            </div>

  
          </div>


        
            
        <!-- Etunimi ja sukunimi -->
        <p class="semiboldgraytext16 mb-1 mt-4">Kuvaus:</p>
        <p class="normaltextgray14 mb-0">Kirjoita tähän kuvaus, jotta muut palveluntarjoajat osaavat antaa tarkkoja tarjouksia.</p>
          <div class="col-12 row m-0 pt-2">
  
            <div class="form-floating mb-2 col-8 p-0">
                <textarea type="text" style="height:250px" placeholder="Kuvaus" formControlName="description" id="deription" class="form-control" ></textarea>
                <label for="addInfo">Kuvaus</label>

            </div>
            </div>
            
            <p class="semiboldgraytext16 mb-1">Hinta</p>
            <p><strong>Ilmoituksen hinta:</strong> {{current_price}}€ alv.0%</p>
              <div class="form-inline mt-4 pb-4">
                <div class="form-group mb-2 flex-row">
                  <button [disabled]="form.invalid" class="btn btn-formed-main-green w-100"><i class="fas fa-sign-in-alt me-2"></i>{{btnText}}</button>
                </div>
              </div>
            </form>
  
          </div>
        </div>

  </div>
        </div>
  </div>
    </div>

    <!-- Modal Check before deleting offer -->
    <button data-bs-toggle="modal" id="open-subtypes" data-bs-target="#open-subtypes-modal" style="display:none"></button>
    <div class="modal fade" id="open-subtypes-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Valitse listasta alakategoria</h5>
            <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
            <button type="button" class="close" id="close-sub-md-modal" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <h5 class="text-center">Valitse alakategoria</h5>
            <div class="col-12 row m-0 pt-4 pb-4">
                <div class="table-responsive" *ngIf="selectedSubtypes && selectedSubtypes.length > 0">
                    <table class="table align-items-center table-flush">
                        <thead class="thead-light">
                            <tr>
                                <th>Nimi</th>
                                <th>Valitse</th>
                            </tr>
                        </thead>
                        <tbody class="tbody-light">
                            <tr *ngFor="let data of selectedSubtypes">
                                <td>{{data.name_fi}}</td>
                                <td><button class="btn btn-formed-main-green" (click)="selectSubtype(data)"><i class="fas fa-plus-circle me-2"></i>Lisää</button></td>
                            </tr>
                        </tbody>
      
                    </table>
                </div>
            </div>
        </div>
        </div>
    </div>
    </div>


    

